import React from 'react';
import './styles.scss';

const BlockEmbed = ({ block }) => {
  const { code } = block;
  const isVideo = code && code.includes('<iframe') && code.includes('youtube');

  return <div className={`ui-block-embed ${isVideo ? 'is-video' : ''}`} dangerouslySetInnerHTML={{ __html: code }} />;
};

export default BlockEmbed;
